module.exports = __webpack_public_path__ + "img/scholl_logo.1b5e532b.png";